
import {
  FaUser,
  FaEnvelope,
  FaBuilding,
  FaPhone,
  FaIdCard,
  FaFileAlt,
} from "react-icons/fa"

const ProfileSection = ({ selectedUser = {} }) => {
  const {
    username,
    email,
    company_name,
    phone,
    gstin,
    pan,
    type,              // ← FETCH TYPE (main / firm)
    firms = null,
    partners = null,
  } = selectedUser || {}

  const profileFields = [
    { label: "Username", value: username, icon: FaUser },
    { label: "Email", value: email, icon: FaEnvelope },
    { label: "Company Name", value: company_name, icon: FaBuilding },
    { label: "Phone Number", value: phone, icon: FaPhone },
    { label: "GSTIN Number", value: gstin, icon: FaIdCard },
    { label: "PAN Number", value: pan, icon: FaFileAlt },
  ]

  return (
    <div className="profile-tab">

      <div className="section-header">
        <FaUser className="section-icon" />
        <h2>User Profile</h2>
      </div>

      <div className="profile-grid">

        {/* ================= MAIN USER CARD ================= */}
        <div className="profile-card">
          <span className="tag top-right">
            {(type || "main").toUpperCase()}
          </span>

          <div className="profile-details">
            {profileFields.map(({ label, value, icon: Icon }) => (
              <div className="profile-field" key={label}>
                <label>
                  <Icon className="field-icon" />
                  {label}:
                </label>
                <span>{value ?? "Not provided"}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= FIRMS SECTION ================= */}
        {firms && (
          <div className="profile-card">
            <div className="profile-details">
              {Object.entries(firms).map(([firmId, firmObj]) => {
                const firm = firmObj || {}

                return (
                  <div key={firmId} className="profile-subcard">

                    {/* FIRM TYPE BADGE */}
                    <span className="tag top-right">
                      {(firm.type || "firm").toUpperCase()}
                    </span>

                    <div className="profile-field">
                      <label>
                        <FaBuilding className="field-icon" />
                        Company Name:
                      </label>
                      <span>{firm.company_name ?? "Not provided"}</span>
                    </div>

                    <div className="profile-field">
                      <label>
                        <FaIdCard className="field-icon" />
                        GSTIN:
                      </label>
                      <span>{firm.gstin ?? firm.gst ?? "Not provided"}</span>
                    </div>

                    <div className="profile-field">
                      <label>
                        <FaFileAlt className="field-icon" />
                        PAN:
                      </label>
                      <span>{firm.pan ?? "Not provided"}</span>
                    </div>

                    {firm.pwd && (
                      <div className="profile-field">
                        <label>Password hash:</label>
                        <span className="muted">{firm.pwd}</span>
                      </div>
                    )}

                    <hr />
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {/* ================= PARTNERS SECTION ================= */}
        {partners && (
          <div className="profile-card">
            <span className="tag top-right">PARTNER</span>

            <div className="profile-details">
              {Object.entries(partners).map(([partnerId, partnerObj]) => {
                const partner = partnerObj || {}

                return (
                  <div key={partnerId} className="profile-subcard">
                    <div className="profile-field">
                      <label>
                        <FaUser className="field-icon" />
                        Name:
                      </label>
                      <span>
                        {partner.username ?? partner.name ?? "Not provided"}
                      </span>
                    </div>

                    <div className="profile-field">
                      <label>
                        <FaPhone className="field-icon" />
                        Phone:
                      </label>
                      <span>{partner.phone ?? "Not provided"}</span>
                    </div>

                    <div className="profile-field">
                      <label>
                        <FaEnvelope className="field-icon" />
                        Email:
                      </label>
                      <span>{partner.email ?? "Not provided"}</span>
                    </div>

                    <hr />
                  </div>
                )
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default ProfileSection